import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEljuevesComponent } from './simple-icons-eljueves.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEljuevesComponent ],
    exports:      [ SimpleIconsEljuevesComponent ],
    bootstrap:    []
})
export class SimpleIconsEljuevesModule {}
